import React from 'react'
import { Form, Row, Col } from 'antd'
import { Input, Radio } from 'ui/styled'
import { Label } from 'pages/Ticket/styled'
import ConditionSelect from 'components/ConditionSelect'

const { Group: RadioGroup } = Radio

const requested_by_prior_auth_options = [
  { label: 'Member', value: 'member' },
  { label: 'Provider', value: 'provider' }
]

const requested_by_override_options = [
  { label: 'Member', value: 'member' },
  { label: 'Pharmacy', value: 'pharmacy' }
]

const status_options = [
  { label: 'Approved', value: 'approved' },
  { label: 'Denied', value: 'denied' }
]

const new_start_or_cot_options = [
  { label: 'New Start', value: 'new_start' },
  { label: 'COT', value: 'cot' }
]

const { Item } = Form

const PbmContactCenterFields = ({ isOverride, isPriorAuthorization }) => {
  return (
    <>
      <Row>
        <Col span={11}>
          <Label>Claim ID</Label>
          <Item name="claim_id">
            <Input placeholder="Claim ID" />
          </Item>
        </Col>
        <Col span={12} offset={1}>
          <Label>Medication</Label>
          <Item name="medication">
            <Input placeholder="Medication" />
          </Item>
        </Col>
      </Row>

      {isPriorAuthorization && (
        <>
          <Row>
            <Col span={8}>
              <Label required>Requested By</Label>
              <Item name="requested_by" rules={[{ required: true }]}>
                <RadioGroup options={requested_by_prior_auth_options} />
              </Item>
            </Col>
            <Col span={8} style={{ paddingLeft: 10, paddingRight: 10 }}>
              <Label>Diagnosis Code</Label>
              <Item name="symptom_id">
                <Input placeholder="Diagnosis Code" />
              </Item>
            </Col>
            <Col span={8}>
              <Label>Symptom Name</Label>
              <Item name="symptom_name">
                <ConditionSelect placeholder="Symptom Name" skipStringify />
              </Item>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Label required>New Start or COT</Label>
              <Item name="new_start_or_cot" rules={[{ required: true }]}>
                <RadioGroup options={new_start_or_cot_options} />
              </Item>
            </Col>
            <Col span={8} style={{ paddingLeft: 10, paddingRight: 10 }}>
              <Label>Tried and Failed Medications</Label>
              <Item name="tried_and_failed_medications">
                <Input placeholder="Tried and failed medications" />
              </Item>
            </Col>
            <Col span={8}>
              <Label>MHK RX Case Number</Label>
              <Item name="mhk_rx_case_number">
                <Input placeholder="MHK RX Case Number" />
              </Item>
            </Col>
          </Row>
        </>
      )}
      {isOverride && (
        <>
          <Row>
            <Col span={8}>
              <Label required>Requested By</Label>
              <Item name="requested_by" rules={[{ required: true }]}>
                <RadioGroup options={requested_by_override_options} />
              </Item>
            </Col>
            <Col span={8} style={{ paddingLeft: 10, paddingRight: 10 }}>
              <Label required>Status</Label>
              <Item name="status">
                <RadioGroup options={status_options} />
              </Item>
            </Col>
            <Col span={8}>
              <Label>Reason</Label>

              <Item name="reason">
                <Input placeholder="Reason" />
              </Item>
            </Col>
          </Row>
        </>
      )}
    </>
  )
}

export default PbmContactCenterFields
